import Handler from "../Handler";

class AutoCallActionHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processAutoCallActionAck(receivedData);
  }
}

export default AutoCallActionHandler;
